import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=69e3506d&"
import script from "./Postcode.vue?vue&type=script&lang=js&"
export * from "./Postcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports